import React, { useState } from 'react'
import { DataContext } from '../../helper/HelperOne'
import QuotationCreate from './QuotationCreate'
import NavBar from '../nav_bar/Navbar'

function Quotation() {
    const [searchUi, setSearchUi] = useState(true)
    const [searchData, setSearchData] = useState(null)

    return (

        <DataContext.Provider value={{searchUi, setSearchUi, searchData, setSearchData}}>
            <NavBar
                childrenPage={<QuotationCreate/>}
                menuId={28}
            />
        </DataContext.Provider>
    )
}

export default Quotation